<app-header title="Paybee Live Streaming List"></app-header>

<div class="stream-list pt-5 mt-5">
  <ng-container *ngIf="allStreams && allStreams.length">
    <ng-container *ngFor="let stream of allStreams; let idx = index; trackBy: getId">
      <div class="card m-4">
        <div class="row">
          <div class="col-12 header">
            <div class="title"> {{ stream.virtualEventInfo.name }} </div>
            <div class="date"><span>Stream created:</span> {{ stream.created | date : "MMM d, y, h:mm:ss a" }}</div>
            <div class="info"><span>Bandwidth Usage In:</span> {{ formatBytes(stream.bandwidthUsageBytesIn) }}</div>
            <div class="info"><span>Bandwidth Usage Out:</span> {{ formatBytes(stream.bandwidthUsageBytesOut) }}</div>
          </div>
        </div>
        <div class="row p-4">
          <ng-container *ngIf="stream.recordings && stream.recordings.length">
            <ng-container *ngFor="let recording of stream.recordings; let recordingIdx = index; trackBy: getRecordingId">
              <div class="thumbnail col-6 col-md-4 col-xl-3 px-2">
                <a (click)="onShowVideo(recording, stream, idx, recordingIdx)">
                  <ng-container *ngIf="recording && recording.metadata.thumbnails.length > 0; else emptyImage">
                    <div class="video-preview"
                         [style.background-image]="'url(' + recording.metadata.thumbnails[0] + ')'"
                    >

                    </div>
                  </ng-container>
                  <ng-template #emptyImage>
                    <div class="video-preview-empty">
                    </div>
                  </ng-template>
                </a>
                <div class="timestamp">
                  {{ formatTime(recording.metadata.duration) }}
                </div>
                <div class="d-flex links">
                  <div (click)="onLinkClick($event, recording, stream, idx, recordingIdx)" class="download-link"><span>Download</span> <i class="fa fa-download" aria-hidden="true"></i></div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
